<template>
  <div>
    <a-row :gutter="[10, 10]">
      <!-- 订单基本信息 -->
      <a-col :md="24" :sm="24">
        <a-card title="订单基本信息">
          <a-card-grid
            v-for="(item, index) in orderBasicInfo"
            :key="index"
            style="width:25%;height:92px;overflow:overlay;text-align:center"
          >
            <div style="font-weight: bold; margin-bottom: 8px;">{{ item.label }}</div>
            <div style="word-break: break-all;">{{ item.value || '-' }}</div>
          </a-card-grid>
        </a-card>
      </a-col>

      <!-- 收件人信息 -->
      <a-col :md="24" :sm="24">
        <a-card title="收件人信息">
          <a-card-grid
            v-for="(item, index) in consigneeInfo"
            :key="index"
            style="width:25%;height:92px;overflow:overlay;text-align:center"
          >
            <div style="font-weight: bold; margin-bottom: 8px;">{{ item.label }}</div>
            <div style="word-break: break-all;">{{ item.value || '-' }}</div>
          </a-card-grid>
        </a-card>
      </a-col>

      <!-- 包裹信息 -->
      <a-col :md="24" :sm="24">
        <a-card title="包裹信息">
          <a-card-grid
            v-for="(item, index) in packageInfo"
            :key="index"
            style="width:25%;height:92px;overflow:overlay;text-align:center"
          >
            <div style="font-weight: bold; margin-bottom: 8px;">{{ item.label }}</div>
            <div style="word-break: break-all;">{{ item.value || '-' }}</div>
          </a-card-grid>
        </a-card>
      </a-col>

      <!-- 物品列表 -->
      <a-col :md="24" :sm="24">
        <a-card title="物品列表">
          <a-table
            :columns="goodsColumns"
            :dataSource="goodsList"
            :pagination="false"
            size="small"
            bordered
            rowKey="id"
          >
            <template slot="goodsUnitPrice" slot-scope="text, record">
              {{ text }} {{ record.currency }}
            </template>
          </a-table>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  name: 'InnerOrderDetail',
  props: {
    orderData: {
      type: Object,
      required: true,
      default: () => ({})
    },
    goodsList: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      // 物品列表表格列配置
      goodsColumns: [
        {
          title: '商品中文品名',
          dataIndex: 'goodsCnName',
          align: 'center',
          width: 150
        },
        {
          title: '商品英文品名',
          dataIndex: 'goodsEnName',
          align: 'center',
          width: 150
        },
        {
          title: 'SKU',
          dataIndex: 'goodsSku',
          align: 'center',
          width: 120
        },
        {
          title: '商品数量',
          dataIndex: 'goodsQuantity',
          align: 'center',
          width: 100
        },
        {
          title: '商品单价',
          dataIndex: 'goodsUnitPrice',
          align: 'center',
          width: 120,
          scopedSlots: { customRender: 'goodsUnitPrice' }
        },
        {
          title: '海关编码',
          dataIndex: 'customsCode',
          align: 'center',
          width: 120
        }
      ]
    }
  },
  computed: {
    // 订单基本信息
    orderBasicInfo() {
      return [
        { label: '客户单号', value: this.orderData.orderNo },
        { label: '尾程运单号', value: this.orderData.waybillNumber },
        { label: '产品代码', value: this.orderData.productCode },
        { label: '参考号', value: this.orderData.refNo },
        { label: '税号', value: this.orderData.taxId },
        { label: '税号类型', value: this.orderData.taxIdType },
        { label: '身份证', value: this.orderData.idCard },
        { label: '国际代码', value: this.orderData.countryCode },
        { label: '收件人身份证', value: this.orderData.consigneeIdCard },
        { label: '创建时间', value: this.orderData.createTime },
        { label: '创建人', value: this.orderData.creator }
      ]
    },
    // 收件人信息
    consigneeInfo() {
      return [
        { label: '收件人姓名', value: this.orderData.consigneeName },
        { label: '收件人公司', value: this.orderData.consigneeCompany },
        { label: '收件人电话', value: this.orderData.consigneeMobile },
        { label: '收件人邮箱', value: this.orderData.consigneeEmail },
        { label: '收件人国家', value: this.orderData.consigneeCountry },
        { label: '收件人省州', value: this.orderData.consigneeState },
        { label: '收件人城市', value: this.orderData.consigneeCity },
        { label: '收件人邮编', value: this.orderData.consigneeZipCode },
        { label: '收件人地址', value: this.orderData.consigneeAddress }
      ]
    },
    // 包裹信息
    packageInfo() {
      return [
        { label: '重量(kg)', value: this.orderData.weight ? this.orderData.weight + ' kg' : '' },
        { label: '长(cm)', value: this.orderData.length ? this.orderData.length + ' cm' : '' },
        { label: '宽(cm)', value: this.orderData.width ? this.orderData.width + ' cm' : '' },
        { label: '高(cm)', value: this.orderData.height ? this.orderData.height + ' cm' : '' }
      ]
    }
  }
}
</script>

<style scoped>
.ant-card-grid {
  padding: 12px;
  transition: background-color 0.3s ease;
}

.ant-card-grid:hover {
  background-color: #f0f8ff;
  cursor: pointer;
}

.ant-card-grid div:first-child {
  color: #666;
  font-size: 12px;
}

.ant-card-grid div:last-child {
  color: #333;
  font-size: 14px;
  font-weight: 500;
}
</style>
